import { z } from "zod";
import { colorZodSchema } from "../color";
import { colorSetZodSchema } from "../color-sets/color-set";
import { colorValueZodSchema } from "../color-value";
import type { ColorStrict} from "./color-strict";
import { colorStringZodObject } from "./color-strict";

type ColorItem = ColorStrict | string;
const colorItemZodSchema: z.ZodSchema<ColorItem> = z.union([
    z.string(),
    colorStringZodObject,
    colorZodSchema,
    colorValueZodSchema,
    colorSetZodSchema,
]);

export { colorItemZodSchema };
export type { ColorItem };
